import React from 'react'
import AvatarCustom from './AvatarCustom'
import './CustomerReviewDetailModel.scss'
import { formatTimeAgo } from 'helper/formatDate'

export default function CustomerReviewDetailModel({ name, avatar, ratingPoint, content, updatedAt, icon, date }) {
  function renderStars(point = 0) {
    // Google Play sometimes uses half-stars; this simple version rounds to nearest integer
    const n = Math.round(Number(point) || 0)
    const total = 5
    const stars = []
    for (let i = 1; i <= total; i++) {
      stars.push(
        <span key={i} className={i <= n ? 'starOn' : 'star'}>
          ★
        </span>
      )
    }
    return stars
  }
  return (
    <div className="CustomerReviewDetailModel">
      <div className="CustomerReviewDetailModel-info">
        {icon ? icon : <AvatarCustom name={name} src={avatar} />}
        <span className="CustomerReviewDetailModel-info-name">{name}</span>
      </div>
      <div className="CustomerReviewDetailModel-rate">
        {ratingPoint && <div className="CustomerReviewDetailModel-rate-stars">{renderStars(ratingPoint)}</div>}
        {updatedAt && <span className="small">{formatTimeAgo(updatedAt)}</span>}
        {date && <span className="small">{date}</span>}
      </div>
      <div className="CustomerReviewDetailModel-content">
        <p>{content}</p>
      </div>
    </div>
  )
}
